/**
 * @type {Object}
 */
export const READINESS_FILTER_VALUES = {
  READY: 'ready',
  NOT_READY: 'notReady',
};

/**
 * @type {Object}
 */
export const STATUS_FILTER_VALUES = {
  ALL: 'all',
};

/**
 * @type {Object}
 */
export const RESERVATION_FILTERS_VALIDATOR_MAP = {
  backToBack: 'isBackToBack',
  backToBackGuest: 'isBackToBackGuest',
  backToBackOwner: 'isBackToBackOwner',
  checkinOnly: 'isCheckinOnly',
  checkinOwner: 'isCheckinsOwner',
  checkinGuest: 'isCheckinsGuest',
  checkoutOnly: 'isCheckoutOnly',
  checkoutOwner: 'isCheckoutsOwner',
  checkoutGuest: 'isCheckoutsGuest',
  hasReservation: 'hasReservation',
  hold: 'isHold',
  recent: 'isRecent',
  noReservation: 'hasNoReservation',
};

/**
 * @type {Object}
 */
export const PROPERTY_FILTERS_NAMES_TRANSLATION = {
  BUILDINGS: 'buildings',
  GROUPS: 'groups',
  PROPERTY_STATUSES: 'propertyStatuses',
  READINESS: 'readiness',
  RESERVATIONS: 'reservations',
  STATUSES: 'statuses',
  TAGS: 'tags',
};

/**
 * @type {Array.<String>}
 */
export const PROPERTY_FILTERS_NAMES_SCHEDULE = [
  PROPERTY_FILTERS_NAMES_TRANSLATION.BUILDINGS,
  PROPERTY_FILTERS_NAMES_TRANSLATION.GROUPS,
  PROPERTY_FILTERS_NAMES_TRANSLATION.PROPERTY_STATUSES,
  PROPERTY_FILTERS_NAMES_TRANSLATION.READINESS,
  PROPERTY_FILTERS_NAMES_TRANSLATION.RESERVATIONS,
  PROPERTY_FILTERS_NAMES_TRANSLATION.TAGS,
];

/**
 * @type {Array.<String>}
 */
export const PROPERTY_FILTERS_NAMES_PROPERTY_LIST = [
  PROPERTY_FILTERS_NAMES_TRANSLATION.BUILDINGS,
  PROPERTY_FILTERS_NAMES_TRANSLATION.GROUPS,
  PROPERTY_FILTERS_NAMES_TRANSLATION.PROPERTY_STATUSES,
  PROPERTY_FILTERS_NAMES_TRANSLATION.TAGS,
];

/**
 * @type {Array.<String>}
 */
export const PROPERTY_FILTERS_NAMES_TASK_LIST = [
  PROPERTY_FILTERS_NAMES_TRANSLATION.BUILDINGS,
  PROPERTY_FILTERS_NAMES_TRANSLATION.GROUPS,
  PROPERTY_FILTERS_NAMES_TRANSLATION.PROPERTY_STATUSES,
  PROPERTY_FILTERS_NAMES_TRANSLATION.TAGS,
];
